var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"年間休日設定"}},[_c('base-error-guard',[_c('holiday-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }